import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 7px;

  color: ${(props) => props.theme.colors.primary.dark};

  :hover {
    color: ${(props) => props.theme.colors.primary.main};
  }

  margin-bottom: 32px;
`;

export default StyledLink;
